var map = {
	"./coin3-dead.png": 9041,
	"./coin3.png": 834,
	"./coin4-dead.png": 7339,
	"./coin4.png": 5259,
	"./player1-dead.png": 1750,
	"./player1.png": 3846,
	"./player2-dead.png": 336,
	"./player2.png": 3434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1643;